import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import badgeComplete from "../../layout/others/icon_done_success_check.svg";
import badgeErrors from "../../layout/others/exclamation_yellow_flat_icon.svg";
import badgePending from "../../layout/others/icon_clear_filled.svg";
import "./styles.scss";

const StepCircle = ({
  imgSrc,
  imgAlt,
  complete,
  title,
  onClick,
  completionState
}) => {
  const [stepBadgeSrc, setStepBadgeSrc] = useState("pending");
  useEffect(() => {
    if (completionState === "complete") {
      setStepBadgeSrc(badgeComplete);
    } else if (completionState === "withErrors") {
      setStepBadgeSrc(badgeErrors);
    } else {
      setStepBadgeSrc(badgePending);
    }
  }, [completionState]);

  return (
    <div
      className={complete ? "step-circle c-complete" : "step-circle c-pending"}
      onClick={onClick}
    >
      <img className="step-img" src={imgSrc} alt={imgAlt} />
      <span>{title}</span>
      {completionState && (
        <img className="step-badge-img" src={stepBadgeSrc} alt="badge" />
      )}
    </div>
  );
};

export default StepCircle;

StepCircle.propTypes = {
  complete: PropTypes.bool.isRequired,
  imgSrc: PropTypes.string.isRequired,
  imgAlt: PropTypes.string,
  title: PropTypes.string
};
